export function resolveDemoCallLink(href) {
    if (href === '/#demo-call' || href === '#demo-call') {
        const hasDemoCallSection = !!document.querySelector('#demo-call');
        return hasDemoCallSection ? '#demo-call' : '/#demo-call';
    }
    return href;
}
